import { baseQueryWithReauth } from './baseQuery';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const railwaysApi = createApi({
    reducerPath: 'railway',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Formaciones', 'DetailById'],
    endpoints: (builder) => ({
        getRailwayCompanies: builder.query({
            query: ({ filters }) => ({
                url: 'formaciones-ferroviarias/datos-parametricos/ferrocarriles',
                params: filters
            }),
            transformResponse: (response: { data: { ferrocarriles: object[] } }) =>
                response?.data?.ferrocarriles
        }),
        getCompanies: builder.query({
            query: (filters) => ({
                url: 'formaciones-ferroviarias/datos-parametricos/empresas',
                params: filters?.idFerrocarril ? { ...filters, idFerrocarril: filters?.idFerrocarril } : filters
            }),
            transformResponse: (response: { data: { empresas: object[] } }) =>
                response?.data?.empresas
        }),
        getCities: builder.query({
            query: ({ filters }) => ({
                url: 'formaciones-ferroviarias/datos-parametricos/ciudades',
                params: filters
            }),
            transformResponse: (response: { data: { ciudades: object[] } }) =>
                response?.data?.ciudades
        }),
        createWaybill: builder.mutation({
            query: (body) => ({
                url: `formaciones-ferroviarias/cartas-porte`,
                method: 'POST',
                body: body
            })
        }),
        getWaybills: builder.query({
            query: ({ filters }) => ({
                url: 'formaciones-ferroviarias/cartas-porte',
                params: filters
            })
        }),
        getWaybillById: builder.query({
            query: (id) => ({
                url: `formaciones-ferroviarias/cartas-porte/${id}`
            }),
            providesTags: ['DetailById'],
            transformResponse: (response: { data: any }) => response?.data
        }),
        updateWaybillWagon: builder.mutation({
            query: ({ waybillId, wagonNumber, body }) => ({
                url: `formaciones-ferroviarias/cartas-porte/${waybillId}/vagones/${wagonNumber}`,
                method: 'POST',
                body: body
            })
        }),
        getRejectMotives: builder.query({
            query: () => ({
                url: 'formaciones-ferroviarias/datos-parametricos/tipos-inconvenientes'
            }),
            transformResponse: (response: { data: { tiposInconvenientes: any } }) =>
                response?.data?.tiposInconvenientes
        }),
        editWaybill: builder.mutation({
            query: ({ id, body }) => ({
                url: `formaciones-ferroviarias/cartas-porte/${id}`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['DetailById'])
        }),
        downloadWaybillFile: builder.query({
            query: (id) => ({
                url: `formaciones-ferroviarias/cartas-porte/${id}/pdf`
            }),
            transformResponse: (response: { data: { pdf: any } }) => response?.data?.pdf
        }),
        getParrillas: builder.query({
            query: () => ({
                url: 'formaciones-ferroviarias/datos-parametricos/parrillas'
            }),
            transformResponse: (response: { data: { parrillas: any } }) => response?.data?.parrillas
        }),
        createRailway: builder.mutation({
            query: ({ body }) => ({
                url: 'formaciones-ferroviarias',
                method: 'POST',
                body: body
            })
        }),
        getFormacionesFerroviarias: builder.query({
            query: ({ filters }) => ({
                url: 'formaciones-ferroviarias',
                params: filters
            }),
            providesTags: ['Formaciones']
        }),
        getWaybillsByFormacionId: builder.query({
            query: ({ id, filters }) => ({
                url: `formaciones-ferroviarias/${id}/cartas-porte`,
                params: filters
            }),
            keepUnusedDataFor: 60 * 60
        }),
        deleteRailway: builder.mutation({
            query: (id) => ({
                url: `formaciones-ferroviarias/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Formaciones'])
        }),
        internalMovements: builder.mutation({
            query: ({ waybillId, body }) => ({
                url: `formaciones-ferroviarias/cartas-porte/${waybillId}/movimientos-internos`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['DetailById'])
        }),
        getTiposVagones: builder.query({
            query: () => ({
                url: 'formaciones-ferroviarias/datos-parametricos/tipos-contenedores'
            }),
            transformResponse: (response: { data: { tiposContenedores: { id: number, descripcion: string }[] } }) =>
                response?.data?.tiposContenedores
        })
    })
});

export const {
    useInternalMovementsMutation,
    useDeleteRailwayMutation,
    useGetWaybillsByFormacionIdQuery,
    useGetFormacionesFerroviariasQuery,
    useCreateRailwayMutation,
    useGetParrillasQuery,
    useLazyDownloadWaybillFileQuery,
    useEditWaybillMutation,
    useGetRejectMotivesQuery,
    useUpdateWaybillWagonMutation,
    useGetWaybillByIdQuery,
    useLazyGetWaybillByIdQuery,
    useGetTiposVagonesQuery,
    useGetWaybillsQuery,
    useCreateWaybillMutation,
    useGetCitiesQuery,
    useGetCompaniesQuery,
    useGetRailwayCompaniesQuery
} = railwaysApi;
